// Sticky header hide / reveal.
// Scrolling down slides the header up out of the way, scrolling back up brings
// it straight back. Whether it moves at all is gated to <=991px in CSS — this
// only toggles the class.
((window) => {
    const header = document.querySelector('.header-main');

    if (!header) return;

    // Leave the header alone until the user is past this point.
    const offset = 10;
    // Movement smaller than this is ignored (iOS momentum jitter).
    const delta = 5;

    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
        ticking = false;

        const y = Math.max(0, window.scrollY);

        // Not enough movement yet — keep lastY so small scrolls accumulate.
        if (Math.abs(y - lastY) < delta) return;

        if (y > lastY && y > offset) {
            header.classList.add('header-main--hidden');
        } else if (y < lastY) {
            header.classList.remove('header-main--hidden');
        }

        lastY = y;
    };

    const onScroll = () => {
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
})(window);
